import { render, staticRenderFns } from "./AssuranceSimple.vue?vue&type=template&id=875d145e&"
import script from "./AssuranceSimple.vue?vue&type=script&lang=js&"
export * from "./AssuranceSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports